<app-table-card-layout
    #cardLayout
    title="Inbound / outbound comms"
    [isLoading]="isCommLoaded"
    [failed]="commFailed"
    [hasData]="allCommunications().length > 0"
    [errorMessage]="globalMessages.serviceMsgError"
    (retry)="retryComm()"
>
    @if (!isCommLoaded && allCommunications().length > 0) {
    <div class="d-flex flex-row align-items-center psic-gap-3">
        <app-pills
            [pills]="pills()"
            [multiple]="true"
            [selectable]="selectable"
            (filteredDataList)="filteredData($event)"
            [filteredDataFilter]="filteredDataFilter"
        ></app-pills>
        <lib-button
            [disabled]="false"
            [buttonType]="'borderless'"
            [buttonSize]="'medium'"
            [buttonText]="'Reset'"
            (callback)="filterReset()"
        ></lib-button>
    </div>
    } @if(communications().length > 0 || filteredCommunications().length === 0 && filteredDataFilter.length > 0){
    <div [class.d-none]="isCommLoaded" class="d-flex flex-column psic-gap-6">
        @if (!cardLayout.isCompact()) {
        <!-- Standard table view -->
        <div class="table-container" [class.table-container--collapsed]="!showAll() && communications().length > 5">
            <table class="comms-table">
                <thead>
                    <tr>
                        @for (col of cols; track col) {
                        <th
                            [ngStyle]="{ width: col?.width }"
                            class="disclaimer-bold wh-100-background psic-px-4 psic-py-4"
                        >
                            {{ col.header }}
                        </th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (comm of communications(); track comm.attachmentDocId || comm.referenceId; let i = $index) {
                    <tr [class.active]="selectedRowIndex === i">
                        <td class="d-flex flex-column align-center justify-content-center psic-px-3">
                            @if (comm.direction.toLowerCase() === 'out') {
                            <lib-tag
                                [tagText]="'Out'"
                                [tagTheme]="'default'"
                                [tagType]="'colorFill'"
                                [libIcon]="'comm-out'"
                                [iconLeft]="false"
                            ></lib-tag>
                            } @if (comm.direction.toLowerCase() === 'in') {
                            <lib-tag
                                [tagText]="'In'"
                                [tagTheme]="'neutralPurple'"
                                [tagType]="'colorFill'"
                                [libIcon]="'comm-in'"
                                [iconLeft]="false"
                            ></lib-tag>
                            }
                        </td>
                        <td class="referenceId psic-px-3">
                            <span
                                class="clickable-filename p1-50-color disclaimer-bold"
                                (click)="selectRow(i); $event.stopPropagation()"
                            >
                                {{ comm.referenceId }}
                            </span>
                        </td>
                        <td class="others psic-px-3">{{ comm.category }}</td>
                        <td class="others psic-px-3">{{ comm.type }}</td>
                        <td class="others psic-px-3">{{ comm.source }}</td>
                        <td class="others psic-px-3">{{ comm.status }}</td>
                        <td class="others psic-px-3">{{ comm.sendDate }}</td>
                        <td class="others psic-px-3">{{ comm.receivedDate }}</td>
                    </tr>
                    } @empty {
                    <tr>
                        <td colspan="8" class="text-center disclaimer psic-py-4">No communications available.</td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        } @else {
        <!-- Compact 2-column key-value view -->
        <div
            class="compact-list d-flex flex-column psic-gap-6"
            [class.compact-list--collapsed]="!showAll() && communications().length > 5"
        >
            @for (comm of communications(); track comm.attachmentDocId || comm.referenceId; let i = $index) {
            <div
                class="compact-card"
                [class.active]="selectedRowIndex === i"
                (click)="selectRow(i); $event.stopPropagation()"
            >
                <table class="compact-table">
                    <tbody class="d-flex flex-column psic-gap-3 psic-py-3">
                        <tr>
                            <td class="compact-label disclaimer-bold">Out/In</td>
                            <td class="compact-value">
                                @if (comm.direction.toLowerCase() === 'out') {
                                <lib-tag
                                    [tagText]="'Out'"
                                    [tagTheme]="'default'"
                                    [tagType]="'colorFill'"
                                    [libIcon]="'comm-out'"
                                    [iconLeft]="false"
                                ></lib-tag>
                                } @if (comm.direction.toLowerCase() === 'in') {
                                <lib-tag
                                    [tagText]="'In'"
                                    [tagTheme]="'neutralPurple'"
                                    [tagType]="'colorFill'"
                                    [libIcon]="'comm-in'"
                                    [iconLeft]="false"
                                ></lib-tag>
                                }
                            </td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">ReferenceID</td>
                            <td class="compact-value">
                                <span class="clickable-filename p1-50-color disclaimer-bold">{{
                                    comm.referenceId
                                }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Category</td>
                            <td class="compact-value disclaimer">{{ comm.category }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Type</td>
                            <td class="compact-value disclaimer">{{ comm.type }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Source</td>
                            <td class="compact-value disclaimer">{{ comm.source }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Status</td>
                            <td class="compact-value disclaimer">{{ comm.status }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Send date</td>
                            <td class="compact-value disclaimer">{{ comm.sendDate }}</td>
                        </tr>
                        <tr>
                            <td class="compact-label disclaimer-bold">Received date</td>
                            <td class="compact-value disclaimer">{{ comm.receivedDate }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            } @empty {
            <div class="text-center disclaimer psic-py-4">No communications available.</div>
            }
        </div>
        }

        <div class="d-flex flex-row justify-content-center align-items-center w-100">
            @if (!showAll() && communications().length > 5) {
            <lib-button
                [disabled]="false"
                [buttonType]="'borderless'"
                [buttonSize]="'medium'"
                [buttonText]="'Show more'"
                [libIcon]="'chevron-down'"
                (callback)="loadMore()"
            ></lib-button>
            } @else if (showAll() && communications().length > 5) {
            <lib-button
                [disabled]="false"
                [buttonType]="'borderless'"
                [buttonSize]="'medium'"
                [buttonText]="'Show less'"
                [libIcon]="'chevron-up'"
                (callback)="showLess()"
            ></lib-button>
            }
        </div>
    </div>
    }
</app-table-card-layout>
